import {
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {useState} from "react";
import {ResidenceService} from "../../../service/residence/ResidenceService";

const ResidenceCreateNew = ({handleAddNewItemToList}) => {

    const service = new ResidenceService();

    const [title, setTitle] = useState("")
    const [menCapacity, setMenCapacity] = useState(0)
    const [womenCapacity, setWomenCapacity] = useState(0)

    const [loading, setLoading] = useState(false)

    function handleCreateNewResidence() {
        setLoading(true)
        service.createNewResidence(
            title,
            menCapacity,
            womenCapacity,
        ).then(residence => {
            handleAddNewItemToList(residence)
            showSuccessMessage("اقامتگاه جدید با موفقیت افزوده شد.")
        }).catch(error => {
            showServerErrorMessage(error)
        }).finally(() => {
            setLoading(false)
        })
    }

    return <div className={css`margin: 0 1rem 1rem 1rem;`}>
        <RaikoSectionContainer
            title={"افزودن اقامتگاه"}
            hasActionButton
            actionButtonOnclickWithValidation={handleCreateNewResidence}
            actionButtonTitle={"افزودن"}
            actionButtonLoadingState={loading}
        >
            <RaikoSimpleInputOutlined
                labelText={"نام اقامتگاه"}
                value={title}
                setValue={setTitle}
                required
            />

            <RaikoNumberInputOutlined
                labelText={"ظرفیت آقا"}
                value={menCapacity}
                setValue={setMenCapacity}
                required
            />
            <RaikoNumberInputOutlined
                labelText={"ظرفیت خانم"}
                value={womenCapacity}
                setValue={setWomenCapacity}
                required
            />
        </RaikoSectionContainer>
    </div>
}


export default ResidenceCreateNew;